const convocatoriasWeb = {
    GuardarAsistenteAConvocatoria:"/SICPO/ConvoatoriasPagina/GuardarAsistenteAConvocatoria",
    GuardarFormularioConvocatoria: "/SICPO/ConvocatoriasPagina/addFormFields",
    GetTypeField: "SICPO/ConvocatoriasPagina/getTypeFields",
    ObtenerFormularioPorId:"SCPO/ObtenerFormulario",
    ObtenerAsistentesPorConvocatoria:"/SICPO/ConvocatoriasPagina/getListDocsCandidate"

}

export default convocatoriasWeb;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/paginaweb/convocatoriasWeb/convocatoriasWeb.js
// module id = null
// module chunks = 